<template>
    <div class="favorites-enter-card" ref="enterCard">
        <div class="favorites-content">
            <div class="cover"><img :src="pictureUrl" alt="" /></div>
            <div class="card-info">
                <p class="text">
                    {{ $TL.saveTo }}<span>{{ favoritesEnterCardName }}</span
                    >{{ $TL.favorites }}
                </p>
                <a
                    href="javascript:;"
                    class="look-now"
                    @click="faorites_look_now"
                    >{{ $TL.lookNow }}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 22 22"
                        width="18px"
                        height="18px"
                        fill="#3c4043"
                    >
                        <path
                            d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { timeout } from "@/utils/util.js";
import { mapMutations, mapState } from "vuex";
export default {
    name: "favorites-enter-card",
    data() {
        return {};
    },
    created() {},
    mounted() {
        this.auto_hide();
    },
    computed: {
        ...mapState("favorites", [
            "favoritesEnterCardName",
            "favoritesId",
            "pictureAmount",
            "pictureUrl"
        ])
    },
    methods: {
        ...mapMutations("favorites", ["updateFavariteEnterCardShow"]),
        faorites_look_now() {
            const { href } = this.$router.resolve({
                path: `/favorites-details?name=${this.favoritesEnterCardName}&fav_count=${this.pictureAmount}&id=${this.favoritesId}`
            });
            window.open(href, "_blank");

            this.updateFavariteEnterCardShow(false);
        },
        async auto_hide() {
            await timeout(6000);
            this.updateFavariteEnterCardShow(false);
        }
    }
};
</script>

<style lang="scss">
.favorites-enter-card {
    position: fixed;
    left: 22px;
    bottom: 60px;
    z-index: 1000;
    background-color: $color-white;
    box-shadow: 0 3px 6px rgba(#000000, 0.16);
    border-radius: 4px;
    min-width: 340px;

    .favorites-content {
        padding: 12px;
        @include flex(center);
    }

    .cover {
        width: 120px;
        height: 80px;
        border: 1px solid rgba(#999, 0.14);
        position: relative;

        img {
            max-width: 100%;
            max-height: 100%;
            display: block;
            object-fit: cover;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .card-info {
        flex-shrink: 0;
        padding-left: 16px;

        .text {
            font-size: 14px;
            margin-bottom: 6px;

            span {
                font-weight: 700;
                text-decoration: underline;
                padding: 0 2px;
            }
        }
    }

    .look-now {
        padding: 4px 0;
        font-weight: 700;
        font-size: 14px;
        color: $color-font;

        &:hover {
            color: #2874e5;
            svg {
                transform: translateX(4px);
                fill: #2874e5;
            }
        }
        svg {
            margin-left: 4px;
            margin-bottom: -2px;
            transition: all 0.3s ease;
        }
    }
}
</style>
